import { createSvgIcon } from '@mui/material';

export const TransactionStatusIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1.25 11.25C1.94036 11.25 2.5 10.6904 2.5 10C2.5 9.30964 1.94036 8.75 1.25 8.75C0.559644 8.75 0 9.30964 0 10C0 10.6904 0.559644 11.25 1.25 11.25Z"
      fill="#686C75"
    />
    <path
      d="M3.58157 6.25145C3.92675 5.65359 3.7219 4.8891 3.12404 4.54392C2.52617 4.19874 1.76168 4.40359 1.4165 5.00145C1.07133 5.59932 1.27617 6.36381 1.87404 6.70898C2.4719 7.05416 3.23639 6.84932 3.58157 6.25145Z"
      fill="#686C75"
    />
    <path
      d="M6.24904 3.5845C6.8469 3.23932 7.05175 2.47483 6.70657 1.87697C6.36139 1.2791 5.5969 1.07426 4.99904 1.41943C4.40117 1.76461 4.19633 2.5291 4.5415 3.12697C4.88668 3.72483 5.65117 3.92968 6.24904 3.5845Z"
      fill="#686C75"
    />
    <path
      d="M6.70632 18.123C7.0515 17.5252 6.84666 16.7607 6.24879 16.4155C5.65093 16.0703 4.88644 16.2752 4.54126 16.873C4.19608 17.4709 4.40093 18.2354 4.99879 18.5806C5.59666 18.9257 6.36115 18.7209 6.70632 18.123Z"
      fill="#686C75"
    />
    <path
      d="M3.12709 15.4561C3.72495 15.1109 3.9298 14.3464 3.58462 13.7485C3.23944 13.1507 2.47495 12.9458 1.87709 13.291C1.27922 13.6362 1.07438 14.4007 1.41956 14.9985C1.76473 15.5964 2.52922 15.8013 3.12709 15.4561Z"
      fill="#686C75"
    />
    <path
      d="M10 0V2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5V20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0Z"
      fill="#686C75"
    />
    <path
      d="M13.1782 6.61572L9.0626 10.7313L6.82197 8.49072L5.05322 10.2595L8.17822 13.3845C8.29431 13.5007 8.43218 13.5929 8.58392 13.6558C8.73567 13.7187 8.89833 13.7511 9.0626 13.7511C9.22687 13.7511 9.38953 13.7187 9.54127 13.6558C9.69302 13.5929 9.83088 13.5007 9.94697 13.3845L14.947 8.38447L13.1782 6.61572Z"
      fill="#686C75"
    />
  </svg>,
  'TransactionStatusIcon',
);
